module.exports = __webpack_public_path__ + "img/belonogov.a60e4d91.jpg";